module.exports = __webpack_public_path__ + "img/spices.c9247ae7.jpg";